import Vue from 'vue'
import Router from 'vue-router'
import DashboardView from '@/modules/Dashboard/DashboardView'
import ReleaseNotesView from '@/components/ReleaseNotesView'
import ContaView from '@/modules/Conta/ContaView'
import DownloadLinksResetSenhasUsuariosFriosView from '@/modules/Conta/DownloadLinksResetSenhasUsuariosFriosView'
import LoginView from '@/modules/Login/LoginView'
import EmpresaView from '@/modules/Login/EmpresaView'
import ResultadoImportacaoUsuariosView from '@/modules/Conta/ResultadoImportacaoUsuariosView'
import PaginaNaoEncontradaView from '@/components/PaginaNaoEncontradaView'
import TipoPerfil from '@/core/types/tipo-perfil'
import Authorization from '@/core/auth/authorization'
import ConteudoView from '@/modules/Conteudo/ConteudoView'
import CupomView from '@/modules/Cupom/CupomView'
import LiveView from '@/modules/Live/LiveView'
import JaleklinicoView from '@/modules/Jaleklinico/JaleklinicoView'
import DestaqueView from '@/modules/Destaque/DestaqueView'
import AdicionarJaleklinicoView from '@/modules/Jaleklinico/AdicionarJaleklinicoView'
import UsuarioView from '@/modules/Usuario/UsuarioView'
import CortesiaView from '@/modules/Cortesia/CortesiaView'
import NotificacoesView from '@/modules/Notificacoes/NotificacoesView'
import CertificadosView from '@/modules/Certificados/CertificadosView'
import PublicoAlvoView from '@/modules/PublicoAlvo/PublicoAlvoView'
import ResultadoImportacaoQuestaoView from '@/modules/Conteudo/ResultadoImportacaoQuestaoView'
import ResultadoImportacaoCupomView from '@/modules/Cupom/ResultadoImportacaoCupomView'
import AdicionarCursoView from '@/modules/Conteudo/AdicionarCursoView'
import AdicionarEmentaView from '@/modules/Conteudo/AdicionarEmentaView'
import EditarSimuladoView from '@/modules/Conteudo/EditarSimuladoView'
import ImportarVideoView from '@/modules/Conteudo/components/ImportarVideoView'
import AdminView from '@/modules/Admin/AdminView'
import LoginPorTokenView from '@/modules/Login/LoginPorTokenView'
import FlashcardsView from '@/modules/Flashcards/FlashcardsView'
import AssinaturasView from '@/modules/Assinaturas/AssinaturasView'
import CriarAssinaturaView from '@/modules/Assinaturas/CriarAssinaturaView'
import BrindesView from '@/modules/Brindes/BrindesView'
import ResultadoMigracaoProgressoUsuariosView from '@/modules/Conta/ResultadoMigracaoProgressoUsuariosView'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      meta: { requiresLogin: true }
    },
    {
      path: '/home',
      redirect: '/dashboard',
      meta: { requiresLogin: true, adminType: 'Conteudo', requiresCompany: true }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView
    },
    {
      path: '/empresa',
      name: 'empresa',
      component: EmpresaView
    },
    {
      path: '/dashboard/:activeTab?',
      name: 'DashboardView',
      component: DashboardView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        requiresCompany: true }
    },
    {
      path: '/conta/:activeTab?',
      name: 'conta',
      component: ContaView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        permissions:
          [ TipoPerfil.MASTER, TipoPerfil.ADMIN,
            TipoPerfil.ADMIN_RESTRITO, TipoPerfil.ADMIN_JALEKO ],
        requiresCompany: true }
    },
    {
      path: '/conta/importacao/resultado',
      name: 'resultado-importacao-usuarios',
      component: ResultadoImportacaoUsuariosView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        permissions:
        [ TipoPerfil.MASTER, TipoPerfil.ADMIN,
          TipoPerfil.ADMIN_RESTRITO, TipoPerfil.ADMIN_JALEKO ],
        requiresCompany: true }
    },
    {
      path: '/conta/download/links-reset-senhas/usuarios-frios',
      name: 'conta-download-links-reset-senhas-usuarios-frios',
      component: DownloadLinksResetSenhasUsuariosFriosView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        permissions:
        [ TipoPerfil.MASTER, TipoPerfil.ADMIN,
          TipoPerfil.ADMIN_RESTRITO, TipoPerfil.ADMIN_JALEKO ],
        requiresCompany: true }
    },
    {
      path: '/conteudo',
      redirect: '/conteudo/plataforma',
      meta: { requiresLogin: true }
    },
    {
      path: '/conteudo/plataforma/:activeTab?',
      name: 'conteudo',
      component: ConteudoView,
      meta: {
        requiresLogin: true,
        adminType: 'Conteudo',
        permissions:
          [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.ADMIN,
            TipoPerfil.ADMIN_RESTRITO, TipoPerfil.PROFESSOR,
            TipoPerfil.ANALISTA, TipoPerfil.MASTER,
            TipoPerfil.EDITOR ],
        requiresCompany: true }
    },
    {
      path: '/cupom/:activeTab?',
      name: 'cupom',
      component: CupomView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        permissions: [ TipoPerfil.ADMIN_JALEKO ],
        requiresCompany: true }
    },
    {
      path: '/cupom/importacao/resultado',
      name: 'resultado-importacao-cupom',
      component: ResultadoImportacaoCupomView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        permissions: [ TipoPerfil.ADMIN_JALEKO ],
        requiresCompany: true }
    },
    {
      path: '/live/:activeTab?',
      name: 'live',
      component: LiveView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        permissions:
          [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.ADMIN,
            TipoPerfil.ADMIN_RESTRITO, TipoPerfil.PROFESSOR,
            TipoPerfil.ANALISTA, TipoPerfil.MASTER,
            TipoPerfil.EDITOR ],
        requiresCompany: true }
    },
    {
      path: '/conteudo/jaleklinico/:activeTab?',
      name: 'jaleklinico',
      component: JaleklinicoView,
      meta: {
        requiresLogin: true,
        adminType: 'Conteudo',
        permissions:
          [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.ADMIN,
            TipoPerfil.ADMIN_RESTRITO, TipoPerfil.PROFESSOR,
            TipoPerfil.ANALISTA, TipoPerfil.MASTER,
            TipoPerfil.EDITOR ],
        requiresCompany: true }
    },
    {
      path: '/conteudo/destaque/:activeTab?',
      name: 'destaques',
      component: DestaqueView,
      meta: {
        requiresLogin: true,
        adminType: 'Conteudo',
        permissions: [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.EDITOR ],
        requiresCompany: true
      }
    },
    {
      path: '/conteudo/criticas-sugestoes/:activeTab?',
      name: 'criticas-sugestoes',
      component: Vue.component('<component />'),
      meta: {
        requiresLogin: true,
        adminType: 'Conteudo',
        permissions:
          [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.ADMIN,
            TipoPerfil.ADMIN_RESTRITO, TipoPerfil.PROFESSOR,
            TipoPerfil.ANALISTA, TipoPerfil.MASTER,
            TipoPerfil.EDITOR ],
        requiresCompany: true
      }
    },
    {
      path: '/conteudo/jaleklinico/adicionar/:activeTab?',
      name: 'adicionar-jaleklinico',
      component: AdicionarJaleklinicoView,
      props: true,
      meta: {
        requiresLogin: true,
        adminType: 'Conteudo',
        permissions: [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.EDITOR ],
        requiresCompany: true }
    },
    {
      path: '/cortesia/:activeTab?',
      name: 'cortesia',
      component: CortesiaView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        permissions: [ TipoPerfil.ADMIN_JALEKO ],
        requiresCompany: true }
    },
    {
      path: '/notificacoes/:activeTab?',
      name: 'notificacoes',
      component: NotificacoesView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        permissions:
          [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.ADMIN,
            TipoPerfil.ADMIN_RESTRITO, TipoPerfil.PROFESSOR,
            TipoPerfil.ANALISTA, TipoPerfil.MASTER,
            TipoPerfil.EDITOR ],
        requiresCompany: true }
    },
    {
      path: '/certificados/:activeTab?',
      name: 'certificados',
      component: CertificadosView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        permissions:
          [ TipoPerfil.ADMIN_JALEKO ],
        requiresCompany: true }
    },
    {
      path: '/publico-alvo/:activeTab?',
      name: 'publico-alvo',
      component: PublicoAlvoView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        permissions: [
          TipoPerfil.ADMIN_JALEKO, TipoPerfil.ADMIN,
          TipoPerfil.ADMIN_RESTRITO, TipoPerfil.PROFESSOR,
          TipoPerfil.ANALISTA, TipoPerfil.MASTER,
          TipoPerfil.EDITOR ],
        requiresCompany: true
      }
    },
    {
      path: '/usuario/:activeTab?',
      name: 'usuario',
      component: UsuarioView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        permissions: [ TipoPerfil.ADMIN_JALEKO ],
        requiresCompany: true }
    },
    {
      path: '/conteudo/plataforma/importacao/questao/resultado',
      name: 'resultado-importacao-questao',
      component: ResultadoImportacaoQuestaoView,
      meta: {
        requiresLogin: true,
        adminType: 'Conteudo',
        permissions:
          [ TipoPerfil.MASTER, TipoPerfil.ADMIN,
            TipoPerfil.ADMIN_RESTRITO, TipoPerfil.ADMIN_JALEKO,
            TipoPerfil.EDITOR ],
        requiresCompany: true }
    },
    {
      path: '/conteudo/plataforma/cursos/adicionar/:activeTab?',
      name: 'adicionar-curso',
      component: AdicionarCursoView,
      props: true,
      meta: {
        requiresLogin: true,
        adminType: 'Conteudo',
        permissions:
          [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.ADMIN,
            TipoPerfil.ADMIN_RESTRITO, TipoPerfil.PROFESSOR,
            TipoPerfil.ANALISTA, TipoPerfil.MASTER,
            TipoPerfil.EDITOR ],
        requiresCompany: true }
    },
    {
      path: '/conteudo/plataforma/cursos/ementas/adicionar/:activeTab?',
      name: 'adicionar-ementa',
      component: AdicionarEmentaView,
      props: true,
      meta: {
        requiresLogin: true,
        adminType: 'Conteudo',
        permissions:
          [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.ADMIN,
            TipoPerfil.ADMIN_RESTRITO, TipoPerfil.PROFESSOR,
            TipoPerfil.ANALISTA, TipoPerfil.MASTER,
            TipoPerfil.EDITOR ],
        requiresCompany: true }
    },
    {
      path: '/conteudo/plataforma/simulados/editar',
      name: 'editar-simulado',
      component: EditarSimuladoView,
      props: true,
      meta: {
        requiresLogin: true,
        adminType: 'Conteudo',
        permissions:
        [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.ADMIN,
          TipoPerfil.ADMIN_RESTRITO, TipoPerfil.PROFESSOR,
          TipoPerfil.ANALISTA, TipoPerfil.MASTER,
          TipoPerfil.EDITOR ],
        requiresCompany: true }
    },
    {
      path: '/conteudo/plataforma/videos/importar/:videoType?',
      name: 'importar-video',
      component: ImportarVideoView,
      props: true,
      meta: {
        requiresLogin: true,
        adminType: 'Conteudo',
        permissions: [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.EDITOR ] }
    },
    {
      name: 'release-notes',
      path: '/dev/internal/release-notes',
      component: ReleaseNotesView
    },
    {
      path: '/conteudo/admin/:activeTab?',
      name: 'admin',
      component: AdminView,
      meta: {
        requiresLogin: true,
        adminType: 'Conteudo',
        permissions:
          [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.ADMIN,
            TipoPerfil.ADMIN_RESTRITO, TipoPerfil.PROFESSOR,
            TipoPerfil.ANALISTA, TipoPerfil.MASTER,
            TipoPerfil.EDITOR ],
        requiresCompany: true }
    },
    {
      name: 'not-found',
      path: 'not-found',
      alias: '*',
      component: PaginaNaoEncontradaView
    },
    {
      path: '/login/token/:token',
      name: 'login-por-token',
      component: LoginPorTokenView
    },
    {
      path: '/conteudo/flashcards/:activeTab?',
      name: 'flashcards',
      component: FlashcardsView,
      meta: {
        requiresLogin: true,
        adminType: 'Conteudo',
        permissions: [
          TipoPerfil.ADMIN_JALEKO, TipoPerfil.ADMIN,
          TipoPerfil.ADMIN_RESTRITO, TipoPerfil.PROFESSOR,
          TipoPerfil.ANALISTA, TipoPerfil.MASTER,
          TipoPerfil.EDITOR ],
        requiresCompany: true
      }
    },
    {
      path: '/assinaturas/:activeTab?',
      name: 'assinaturas',
      component: AssinaturasView,
      meta: { requiresLogin: true, permissions: [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.MASTER, TipoPerfil.ADMIN ] }
    },
    {
      path: '/assinaturas/criar-assinatura-boleto/:activeTab?',
      name: 'criar-assinatura-boleto',
      component: CriarAssinaturaView,
      props: true,
      meta: { requiresLogin: true, adminType: 'Usuario', permissions: [ TipoPerfil.ADMIN_JALEKO, TipoPerfil.ADMIN, TipoPerfil.ADMIN_RESTRITO, TipoPerfil.PROFESSOR, TipoPerfil.ANALISTA, TipoPerfil.MASTER, TipoPerfil.EDITOR ], requiresCompany: true }
    },
    {
      path: '/brindes/:activeTab?',
      name: 'brindes',
      component: BrindesView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        permissions: [ TipoPerfil.ADMIN_JALEKO ],
        requiresCompany: true
      }
    },
    {
      path: '/conta/migracao/resultado',
      name: 'resultado-migracao-progresso-usuarios',
      component: ResultadoMigracaoProgressoUsuariosView,
      meta: {
        requiresLogin: true,
        adminType: 'Usuario',
        permissions:
        [ TipoPerfil.MASTER, TipoPerfil.ADMIN,
          TipoPerfil.ADMIN_RESTRITO, TipoPerfil.ADMIN_JALEKO ],
        requiresCompany: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta) {
    if (to.meta.adminType && process.env.VUE_APP_ADMIN_TYPE !== to.meta.adminType) {
      window.location.href = to.path
    }
    const auth = Authorization.authorize(to.meta.requiresLogin, to.meta.permissions, to.meta.requiresCompany)

    if (auth === 'company-required') {
      next({ name: 'empresa', query: { redir: to.path } })
    }

    if (auth === 'login-required') {
      next({ name: 'login', query: { redir: to.path } })
    } else if (auth === 'unauthorized') {
      next({ path: '/not-found' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
